import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Checkbox,
  FormControlLabel,
} from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import TreeItem from '@material-ui/lab/TreeItem';
import TreeView from '@material-ui/lab/TreeView';
import '../../assets/stylesheets/Closet.css';
import { 
  generateCategoryHierarchy, 
  getAllDescendantKeys 
} from '../../helpers/closetHelpers';

class CategoryTreeView extends Component {

  valueIsSelected = (filter, value) => {
    const { appliedFilters } = this.props;
    const filterValues = appliedFilters[filter.name] || [];
    return filterValues.includes(value)
  }

  handleFilterCheckboxChange = (filter, value) => {
    return (event) => {
      const { appliedFilters, selectFilter } = this.props;
      const filterValues = appliedFilters[filter.name] || [];
      if (event.target.checked) {
        const allDescendantKeys = getAllDescendantKeys(filter.values, value, []);
        const updatedKeys = [];
        allDescendantKeys.forEach(key => {
          if (!filterValues.find(existingKey => key === existingKey)) {
            updatedKeys.push(key);
          }
        });
        const updatedFilterValues = filterValues.concat([value], updatedKeys);
        selectFilter(filter, updatedFilterValues);
      } else {
        const allDescendantKeys = getAllDescendantKeys(filter.values, value, []).concat([value]);
        const updatedFilterValues = filterValues.filter(existingKey => !allDescendantKeys.includes(existingKey));
        selectFilter(filter, updatedFilterValues);
      }
    }
  }

  getTreeItemsFromHierarchy = (categoryHierarchy, filter) => {
    return categoryHierarchy.map(category => {
      const children = category.children.length ?
        this.getTreeItemsFromHierarchy(category.children, filter) : undefined;
      return (
        <TreeItem
          key={category.key}
          nodeId={category.key.toString()}
          onLabelClick={event => event.preventDefault()}
          label={
            <FormControlLabel
              className='treeLabel'
              key={category.key}
              label={category.value}
              control={
                <Checkbox
                  checked={this.valueIsSelected(filter, category.key)}
                  onChange={this.handleFilterCheckboxChange(filter, category.key)}
                />
              }
            />
          }
        >
          {children}
        </TreeItem>
      );
    });
  };

  render() {
    const { filter } = this.props;
    const categoryHierarchy = generateCategoryHierarchy(filter.values);
    return (
      <TreeView
        multiSelect
        defaultCollapseIcon={<ExpandMoreIcon />}
        defaultExpandIcon={<ChevronRightIcon />}
        onNodeSelect={(event) => event.stopPropagation()}
      >
        {this.getTreeItemsFromHierarchy(categoryHierarchy, filter)}
      </TreeView>);
  }
}

CategoryTreeView.propTypes = {
  filter: PropTypes.shape({
    fieldType: PropTypes.string,
    multi: PropTypes.bool,
    name: PropTypes.string,
    values: PropTypes.array
  }).isRequired,
  selectFilter: PropTypes.func.isRequired,
  appliedFilters: PropTypes.shape({
    category: PropTypes.array,
    page: PropTypes.number,
    size: PropTypes.number
  }).isRequired
}

export default CategoryTreeView;
